<template>
  <div class="operating-equipament-form text-start">
    <v-form>
      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('employers_quantity') }}
        </label>
        <v-text-field
          v-model="questions.question1"
          flat
          background-color="field_register"
          class="input-register input-company mt-5"
          :label="mountTranslate('quantity')"
          solo
        />
      </div>
      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('operating_in_shifts') }}
        </label>
        <v-textarea
          v-model="questions.question2"
          flat
          background-color="field_register"
          class="input-register mt-5"
          :label="mountTranslate('describe_about')"
          solo
        />
      </div>
      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('risk_map') }}
        </label>
        <v-radio-group
          v-model="questions.question3"
          class="radio-company"
        >
          <v-radio
            class="mb-5"
            :label="mountTranslate('no')"
            :value="false"
          />
          <v-radio
            :label="mountTranslate('yes')"
            :value="true"
          />
        </v-radio-group>
      </div>
      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('hierarchy') }}
        </label>
        <v-textarea
          v-model="questions.question4"
          flat
          background-color="field_register"
          class="input-register mt-5"
          :label="mountTranslate('describe_about')"
          solo
        />
      </div>
      <div class="content-field">
        <label class="title-field">
          {{ mountTranslate('average_periodicity') }}
        </label>
        <v-radio-group
          v-model="questions.question5.average_periodicity"
          class="radio-company"
        >
          <v-radio
            class="mb-5"
            :label="mountTranslate('day')"
            value="daily"
          />
          <v-radio
            class="mb-5"
            :label="mountTranslate('week')"
            value="weekly"
          />
          <v-radio
            class="mb-5"
            :label="mountTranslate('biweekly')"
            value="biweekly"
          />
          <v-radio
            class="mb-5"
            :label="mountTranslate('monthly')"
            value="monthly"
          />
          <v-radio
            class="mb-5"
            :label="mountTranslate('annually')"
            value="annually"
          />
          <v-radio
            :label="mountTranslate('other')"
            value="other"
          />
        </v-radio-group>
        <v-text-field
          v-if="questions.question5.average_periodicity === 'other'"
          v-model="questions.question5.other"
          flat
          background-color="field_register"
          class="input-register"
          :label="mountTranslate('describe_about')"
          solo
        />
      </div>
      <div class="content-field">
        <label
          class="title-field"
        >
          {{ mountTranslate('paper_term_1') }}
          <div class="text-decorator">{{ mountTranslate('paper_term_2') }}</div>
          {{ mountTranslate('paper_term_3') }}
        </label>
        <div>
          <v-select
            id="select-paper"
            v-model="questions.question6"
            :items="tonsSelect"
            :placeholder="mountTranslate('tons.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div class="content-field">
        <label
          class="title-field"
        >
          {{ mountTranslate('plastic_term_1') }}
          <div class="text-decorator">{{ mountTranslate('plastic_term_2') }}</div>
          {{ mountTranslate('plastic_term_3') }}
        </label>
        <div>
          <v-select
            id="select-plastic"
            v-model="questions.question7"
            :items="tonsSelect"
            :placeholder="mountTranslate('tons.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div>
        <label
          class="title-field"
        >
          {{ mountTranslate('metal_term_1') }}
          <div class="text-decorator">{{ mountTranslate('metal_term_2') }}</div>
          {{ mountTranslate('metal_term_3') }}
        </label>
        <div>
          <v-select
            v-model="questions.question8"
            :items="tonsSelect"
            :placeholder="mountTranslate('tons.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div>
        <label
          class="title-field"
        >
          {{ mountTranslate('glass_term_1') }}
          <div class="text-decorator">{{ mountTranslate('glass_term_2') }}</div>
          {{ mountTranslate('glass_term_3') }}
        </label>
        <div>
          <v-select
            id="select-glass"
            v-model="questions.question9"
            :items="tonsSelect"
            :placeholder="mountTranslate('tons.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div>
        <label
          class="title-field"
        >
          {{ mountTranslate('aerossol_packages_screening_term_1') }}
          <div class="text-decorator">
            {{ mountTranslate('aerossol_packages_screening_term_2') }}
          </div>
          {{ mountTranslate('aerossol_packages_screening_term_3') }}
          <div class="text-decorator">
            {{ mountTranslate('aerossol_packages_screening_term_4') }}
          </div>
          {{ mountTranslate('aerossol_packages_screening_term_5') }}
        </label>
        <v-radio-group
          v-model="questions.question10"
          class="radio-company"
        >
          <v-radio
            class="mb-5"
            :label="mountTranslate('no')"
            :value="false"
          />
          <v-radio
            :label="mountTranslate('yes')"
            :value="true"
          />
        </v-radio-group>
      </div>
      <div>
        <label
          class="title-field"
        >
          {{ mountTranslate('aerossol_term_1') }}
          <div class="text-decorator">{{ mountTranslate('aerossol_term_2') }}</div>
          {{ mountTranslate('aerossol_term_3') }}
        </label>
        <div>
          <v-select
            id="select-aerossol"
            v-model="questions.question11"
            :items="tonsSelect"
            :placeholder="mountTranslate('tons.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div>
        <label
          class="title-field"
        >
          {{ mountTranslate('mats_term_1') }}
          <div class="text-decorator">{{ mountTranslate('mats_term_2') }}</div>
          {{ mountTranslate('mats_term_3') }}
        </label>
        <div>
          <v-select
            id="select-mats"
            v-model="questions.question12"
            :items="operatesSelect"
            :placeholder="mountTranslate('operates.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div>
        <label
          class="title-field"
        >
          {{ mountTranslate('presses_term_1') }}
          <div class="text-decorator">{{ mountTranslate('presses_term_2') }}</div>
          {{ mountTranslate('presses_term_3') }}
        </label>
        <div>
          <v-select
            id="select-presses"
            v-model="questions.question13"
            :items="operatesSelect"
            :placeholder="mountTranslate('operates.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div>
        <label
          class="title-field"
        >
          {{ mountTranslate('scales_term_1') }}
          <div class="text-decorator">{{ mountTranslate('scales_term_2') }}</div>
          {{ mountTranslate('scales_term_3') }}
        </label>
        <div>
          <v-select
            id="select-scales"
            v-model="questions.question14"
            :items="operatesSelect"
            :placeholder="mountTranslate('operates.placeholder')"
            class="select-register mt-5"
            background-color="white"
            outlined
          />
        </div>
      </div>
      <div>
        <label class="title-field">
          {{ mountTranslate('calibration_certified') }}
        </label>
        <v-radio-group
          v-model="questions.question15"
          class="radio-company"
        >
          <v-radio
            class="mb-5"
            :label="mountTranslate('no')"
            :value="false"
          />
          <v-radio
            :label="mountTranslate('yes')"
            :value="true"
          />
        </v-radio-group>
      </div>
      <div class="button-access">
        <rectoplus-button
          id="nextSubStep2"
          class="next-button"
          :text="$t('components.register.business.organization.button')"
          @click="nextStep"
        />
      </div>
    </v-form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import RectoplusButton from '@/components/buttons/RectoplusButton.vue';

export default {
  name: 'WasteMerchantOperatignEquipment',
  components: {
    RectoplusButton,
  },
  data() {
    return {
      questions: {
        question1: '',
        question2: '',
        question3: false,
        question4: '',
        question5: {
          average_periodicity: '',
          other: '',
        },
        question6: null,
        question7: null,
        question8: null,
        question9: null,
        question10: false,
        question11: null,
        question12: null,
        question13: null,
        question14: null,
        question15: false,
      },
      tonsSelect: [
        { text: this.mountTranslate('tons.select_0'), value: this.mountTranslate('tons.select_0') },
        { text: this.mountTranslate('tons.select_1'), value: this.mountTranslate('tons.select_1') },
        { text: this.mountTranslate('tons.select_2'), value: this.mountTranslate('tons.select_2') },
        { text: this.mountTranslate('tons.select_3'), value: this.mountTranslate('tons.select_3') },
        { text: this.mountTranslate('tons.select_4'), value: this.mountTranslate('tons.select_4') },
        { text: this.mountTranslate('tons.select_5'), value: this.mountTranslate('tons.select_5') },
        { text: this.mountTranslate('tons.select_6'), value: this.mountTranslate('tons.select_6') },
        { text: this.mountTranslate('tons.select_7'), value: this.mountTranslate('tons.select_7') },
      ],
      operatesSelect: [
        { text: this.mountTranslate('operates.select_1'), value: this.mountTranslate('operates.select_1') },
        { text: this.mountTranslate('operates.select_2'), value: this.mountTranslate('operates.select_2') },
        { text: this.mountTranslate('operates.select_3'), value: this.mountTranslate('operates.select_3') },
        { text: this.mountTranslate('operates.select_4'), value: this.mountTranslate('operates.select_4') },
        { text: this.mountTranslate('operates.select_5'), value: this.mountTranslate('operates.select_5') },
        { text: this.mountTranslate('operates.select_6'), value: this.mountTranslate('operates.select_6') },
      ],
      operatesSelectDefault: { text: this.mountTranslate('operates.placeholder'), value: null },
    };
  },
  computed: {
    ...mapGetters(['getOperatingEquipment', 'hasOperationalCapacity']),
  },
  mounted() {
    if (this.hasOperationalCapacity) this.setQuestions();
  },
  methods: {
    ...mapActions([
      'nextSubStep',
      'setQuestionOperatingEquipment',
    ]),
    mountTranslate(path) {
      return this.$t(`components.stepper_business.sub_steps.waste_merchant.operating_equipment.form.${path}`);
    },
    nextStep() {
      this.setQuestionOperatingEquipment(this.questions);
      this.nextSubStep();
    },
    setQuestions() {
      Object.keys(this.questions).forEach((key) => {
        this.questions[key] = this.getOperatingEquipment[key];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.operating-equipament-form {
  color: $color_field_quiz;
  font-size: 0.875em;

  .content-field {
    margin-bottom: 20px;
  }
  .select-register {
    color: $color_primary;
    border-radius: 10px;
    width: 100%;
  }
  .radio-company {
    font-weight: bold;
  }
  .title-field {
    font-size: 1.25em;
    font-weight: 600;
    .text-decorator {
      display: inline;
      color: $color_primary;
    }
  }
  .button-access {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 40px;
    .next-button {
      width: 100%;
      height: 70px;
      margin-bottom: 20px;
    }
  }
  .input-register{
    border-radius: 8px;
  }
  .input-company {
    width: 220px;
  }
}
</style>
